<template>
    <div>
        <nav-breadcrumb :menu="[{label: '申贷意向'}]"/>
        <el-row>
            <el-col class=" bg-purple">
                <div class="xzpadd10 of">
                    <data-table
                        :table-data="tableData"
                        :columns="columns"
                        :page.sync="page"
                        :pageSize.sync="pageSize"
                        :filters.sync="filters"
                        :actions="actions"
                    />
                </div>
            </el-col>
        </el-row>
        <el-dialog :visible.sync="dialogVisible" title="配置渠道商" >
            <el-form :model="dealerForm"  ref="reportForm" label-width="150px">
                <el-row :gutter="10" class="bg-purple xamhtrpg">
                    <el-col :span="12">
                        <el-form-item label="渠道商：" prop="dealerId" :rules="{required: true, message: '渠道商不能为空'}">
                            <el-select placeholder="请选择渠道商" v-model.trim="dealerForm.dealerId" filterable>
                                <el-option :label="item.label" :value="item.value" v-for="(item,idx) in dealerOptions" :key="idx"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="tr xzmt">
                <el-button type="primary" @click="onSubmit('reportForm')">确认提交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import Status2CN from "../../filters/Status2CN";
    import moment from 'moment'
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "FinancingRequestList",
        data(){
            return{
                requestId:'',
                dealerOptions:[],
                dealerForm:{
                    dealerId:'',
                    requestId:'',
                },

                dialogVisible:false,
                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '客户姓名',
                        field: 't__customerName'
                    },
                    /*{
                        label: '手机号',
                        field: 't__customerContactNo'
                    },*/
                    {
                        label: '申贷金额',
                        field: 't__amount',
                        formatter: (r,c,v) => {
                            return formatMoney(v)
                        },

                    },
                    {
                        label: '期限',
                        field: 't__repaymentCount',
                    },
                    {
                        label: '房产信息',
                        field: 't__propertyOwner',
                    },
                    {
                        label: '分配渠道商',
                        field: 'd__dealerName'
                    },
                    {
                        label: '申请时间',
                        field: 't__requestDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD')
                        }
                    },
                    {
                        label: '状态',
                        field: 't__requestStatus',
                        formatter: function (r, c, v) {
                            return Status2CN('Request__'+v)
                        }
                    },
                    {
                        label: '操作',
                        opts:[
                            {
                                label: '查看',
                                class: 'el-icon-view',
                                clickHandler: (index, row)=> {
                                    this.$router.push(
                                        {
                                            path: 'View',
                                            query: {
                                                requestId: row.t__requestId
                                            }
                                        }
                                    )
                                }
                            },
                            {
                                label: '配置渠道商',
                                class: 'el-icon-edit',
                                clickHandler: (index, row)=> {
                                    this.dialogVisible = true
                                    this.dealerForm.requestId = row.t__requestId
                                },
                                conditions: row=> {
                                    return row.t__requestStatus == 'Open'||row.t__requestStatus == 'Ready'
                                }
                            },
                        ]
                    }
                ],
                tableData: {
                    count: 0,
                    data: []
                },
                page: 1,
                pageSize: 20,
                actions: [
                    {
                        label: '导出',
                        class: 'el-icon-download el-button--primary',
                        clickHandler:()=>{
                            let routeData = this.$router.resolve({
                                path: '/ix/fang/customer/FinancingRequest.List?format=xls',
                                query: Object.assign({
                                    pageSize:0,
                                  /*  'toDate':this.filters.form.toDate,*/
                                }, {
                                  /*  'xlist.sort.dataField': 'fi.startDate',
                                    'xlist.sort.order': 'asc'*/
                                }, xmlBuildQuery(this.filters))
                            });
                            window.open(routeData.href.replace('#/', '/'), '_blank');
                        }
                    }
                ],
                filters: {
                    labelWidth: '150px',
                    form: {
                        t__customerName:'',
                        t__customerContactNo:'',
                        t__requestStatus:'',
                        d__dealerId:'',
                    },
                    columns: [
                        {
                            label: '客户姓名',
                            component: 'el-input',
                            field: 't__customerName'
                        },
                        {
                            label: '申请日期',
                            component: 'date-range-picker',
                            field: 't__requestDate',
                            op: ['gteq', 'lteq'],
                            span: 12
                        },
                       /* {
                            label: '手机号',
                            component: 'el-input',
                            field: 't__customerContactNo'
                        },*/
                        {
                            label: '渠道商',
                            component: 'el-select',
                            field: 'd__dealerId',
                            options:[]
                        },
                        {
                            label: '状态',
                            component: 'el-select',
                            field: 't__requestStatus',
                            options: [
                                {
                                    label:'待分配',
                                    value:'Open'
                                },
                                {
                                    label:'已分配',
                                    value:'Ready'
                                },
                                {
                                    label:'已受理',
                                    value:'Completed'
                                },
                                {
                                    label:'已取消',
                                    value:'Void'
                                },
                            ],
                        },

                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getData()
                    }
                }
            }
        },
        mounted() {
            this.getData()
            this.getDealerList()
        },
        computed: {
            filterParams() {
                return {
                    pageSize: this.pageSize,
                    pageOffset: (this.page - 1) * this.pageSize,
                  /*  'xlist.sort.dataField': 'c.createdDate',
                    'xlist.sort.order': 'desc'*/
                }
            }
        },
        watch: {
            filterParams: function (newVal) {
                this.getData()
            }
        },
        methods: {
            onSubmit: function (formName) {
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        xhr.AssignDealerForFinancingRequest(this.dealerForm, res=> {
                            try {
                                if (res.data.status == 'success') {
                                    this.dealerForm = {
                                        dealerId:'',
                                            requestId:'',
                                    }
                                    this.$router.push({
                                        name: 'FinancingRequestListView'
                                    })
                                    this.getData()
                                    this.dialogVisible = false
                                }
                            } catch (e) {
                            }
                        })
                    }
                })
            },
            getDealerList: function () {
                xhr.getDealerList(
                    Object.assign({pageSize:0}, {}, {}),
                    res=> {
                        try {
                            this.dealerOptions = res.data.data.map(item=>{
                                return {
                                    label: item.d__dealerName,
                                    value:item.d__dealerId,
                                }
                            })
                            this.filters.columns[2].options = res.data.data.map(item=>{
                                return {
                                    label: item.d__dealerName,
                                    value:item.d__dealerId,
                                }
                            })
                        }catch(e){

                        }
                    })

            },
            getData: function () {
                xhr.getFinancingRequestList(
                    Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
                    res=> {
                        try {
                            this.tableData = res.data
                        }catch(e){

                        }
                    })

            },


        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/FinancingRequestList.vue